import h from '../utils/htm';
import http from '../utils/http';
import { mapURL } from '../constants';
import prettifyTime from '../utils/prettifyTime';
import { MarkerWithLabel } from '@googlemaps/markerwithlabel';
import domWrap from '../utils/domWrap';
import Mustache from 'mustache';


let locationAllowed = true;
let lastClickedMarker = null;
const	filters = [
	{ 'Name': 'Elite Support', fnFilter: (location) => { return location.eliteSupport === true; } },
	{ 'Name': 'Parts', fnFilter: (location) => { return location.departments.findIndex(x => x.name === 'Parts') > -1; } },
	{ 'Name': 'Service', fnFilter: (location) => { return location.departments.findIndex(x => x.name === 'Service') > -1; } },
	{ 'Name': 'Distributors', fnFilter: (location) => { return location.entityType === 'Distributor' || location.entityType === 'Distributor Branch'; } },
	{ 'Name': 'Body Shop', fnFilter: (location) => { return location.isBodyShop === true; } }
],
weekDays = [
	'sunday',
	'monday',
	'tuesday',
	'wednesday',
	'thursday',
	'friday',
	'saturday'
],
currentDay = (new Date()).getDay(),
dayOfWeek = weekDays.find((item, index) => {
	return index === currentDay;
});

const svcGeoLocation = (function () {

	const svcBrowser = {
		GetGeoLocation: () => {
			return navigator.geolocation
		}
	}

	const svcMock = {
		GetGeoLocation: () => {
			function getCurrentPosition(fn) {
				const response = {
					coords: {
						accuracy: 173732014426563903,
						altitude: null,
						altitudeAccuracy: null,
						heading: null,
						latitude: 35.884280,
						longitude: -84.229030,
						speed: null
					},
					timestamp: Date.now()
				};
				fn(response);
			}

			return {
				getCurrentPosition
			};
		}
	}

	return (navigator.geolocation)
		? svcBrowser
		: svcMock
})();

const svcGeoMock = {
	GetMap: () => {

		let element = undefined;

		function DirectionsRenderer() { }

		function DirectionsService() { }

		const event = {
			addListener: (element, trigger, fn) => {
				fn();
			},
			trigger: () => { }
		}

		function Geocoder() {
			this.geocode = (options, fnOnReturn) => {
				const results = [
					{
						address_components: [{ long_name: '', short_name: '', types: [] }],
						formatted_address: 'Knoxville, TN, USA',
						geometry: {
							bounds: {
								Ia: { hi: 0, lo: 0 },
								Ua: { hi: 0, lo: 0 }
							},
							location: {
								lat: () => { return 35.960636; },
								lng: () => { return -83.920738; },
								location_type: ''
							},
							viewport: {
								Ia: { hi: 0, lo: 0 },
								Ua: { hi: 0, lo: 0 }
							},
						},
						place_id: '',
						types: []
					}
				];
				const status = 'OK';
				fnOnReturn(results, status);
			}
		}

		function LatLng(lat, lng) {
			this.lat = (lat) => { return lat; }
			this.lng = (lng) => { return lng; }
		}

		function Map(elm, obj, options) {
			element = elm;

			this.getBounds = () => {
				return {
					getNorthEast: () =>
					{
						return {
							lat: () => { return 37.58852546746177; },
							lng: () => { return -81.6960077546875; }
						}
					},
					getSouthWest: () => {
						return {
							lat: () => { return 34.298492348992134; },
							lng: () => { return -86.1454706453125; }
						}
					}
				};
			}
		}
		
		function Point(x, y) { this.x = x, this.y = y }

		function Size(height, width) { this.height = height, this.width = width }

		return {
			Animation: { BOUNCE: 1 },
			DirectionsRenderer,
			DirectionsService,
			DirectionsStatus: { OK: 'OK' },
			Geocoder,
			GeocoderStatus: { OK: 'OK' },
			event,
			LatLng,
			Map,
			places: undefined,
			Point,
			Size,
			TravelMode: { DRIVING: 'DRIVING' }
		};
	}
};

function filterParts(location) {
	const index = location.departments.findIndex(x => x.Name.toLowerCase() === 'parts');
	return index > -1;
}

function drawHours(day) {
	
	const obj = {
		hours: '',	
		label: '',
		status: ''
	};

	if (day !== undefined) {
		if (day.status === 'Closed') {
			obj.label = obj.status = 'Closed';
		} else {
			obj.hours = obj.label = prettifyTime(day.text);
			obj.status = 'Open';
		}
	}

	return obj;
}

function cleanupLocations(locations = []) {
	locations.forEach(location => setTimeout(() => location.marker.setMap(null), 20));
}

function titleCase(str) {
	str = str.replace(/([^\W_]+[^\s-]*) */g, txt => txt.substr(1).length > 2 ? txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase() : txt);

	// Certain minor words should be left lowercase unless 
	// they are the first or last words in the string
	[
		'A', 'An', 'The', 'And', 'But', 'For', 'Nor', 'At',  // , 'As', 'Or', 'In'
		'By', 'For', 'From', 'Into', 'Near', 'Of', 'On', 'Onto', 'To', 'With'
	].forEach(lower => str = str.replace(new RegExp('\\s' + lower+ '\\s', 'ig'), txt => txt.toLowerCase()));

	// Certain words such as initialisms or acronyms should be left uppercase
	[
		'Id', 'Tv'
	].forEach(upper => str = str.replace(new RegExp('\\b' + upper + '\\b', 'g'),upper.toUpperCase()));
	
	return str;
}

function getPolyCoords(legs, coordAccuracy) {
	var polyCoords = [],
		skippedCoords = 0;
	legs.forEach(function(leg) {
		leg.steps.forEach(function(step) {
			step.path.forEach(function(nextSegment) {
				if (skippedCoords < coordAccuracy) {
					skippedCoords += 1;
				}
				else {
					polyCoords.push([nextSegment.lat(), nextSegment.lng()]);
					skippedCoords = 0;
				}
			});
		});
	});
	return polyCoords;
}

function getDistance(lat1, lon1, lat2, lon2) {
	var R = 6371; // Radius of the earth in km
	var dLat = deg2rad(lat2 - lat1);  // deg2rad below
	var dLon = deg2rad(lon2 - lon1);
	var a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
		Math.sin(dLon / 2) * Math.sin(dLon / 2);
	var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	var d = R * c; // Distance in km
	return d * 0.621371; // Return miles
}

function deg2rad(deg) {
	return deg * (Math.PI / 180)
}

function hashCode(code) {
	var hash = 0;
	if (code.length == 0) return hash;
	for (var i = 0; i < code.length; i++) {
		var char = code.charCodeAt(i);
		hash = ((hash << 5) - hash) + char;
		hash = hash & hash; // Convert to 32bit integer
	}
	return hash;
}

export default async dealers => {
	const { default: _ } = await import('lodash'),
		{ default: MapsLoader } = await import('load-google-maps-api'),
		Maps = await MapsLoader({ v: '3.30', key: 'AIzaSyDaQ_hqfOHLci8Vzk7nr5Gis02IhJvEd4U', libraries: ['places'] }),
		dealersElement = domWrap(dealers),
		filtersElement = domWrap(dealersElement.querySelector('[filters]')),
		listContainer = dealersElement.querySelector('[list]'),
		tabs = [],
		detailsPopup = document.getElementById('details-popup'),
		popupBody = document.getElementById('popup-body'),
		popupTemplate = dealers.querySelector('[data-target="[TEMPLATE-DETAILS]"]');
	let accuracy = 10,
		currentLocation = {},
		geo = new Maps.Geocoder(),
		directionsService = new Maps.DirectionsService(),
		directionsDisplay = new Maps.DirectionsRenderer(),
		locations,
		map,
		pendingCall = getListings().catch(()=>{}),
		dataCach = {},
		isFullScreen = () => dealersElement.classList.contains('fullscreen'),
		getListingsUrl = dealersElement.getAttribute('getlistings'),
		root = dealersElement.getAttribute('root') || '',
		getOptions = function() {
			return isFullScreen() ?
				{
					zoom: 10
					, mapTypeControl: false
					, streetViewControl: false
					, scrollwheel: false
					, draggable: true
				} :
				{
					zoom: 8
					, mapTypeControl: false
					, streetViewControl: false
					, scrollwheel: false
					, draggable: true
				};
		},
		lastZ = 100;

	const _emptyDepartment = {
		fax: '',
		phone: '',
		schedule: {
			sunday: drawHours(undefined),
			monday: drawHours(undefined),
			tuesday: drawHours(undefined),
			wednesday: drawHours(undefined),
			thursday: drawHours(undefined),
			friday: drawHours(undefined),
			saturday: drawHours(undefined)
		},
		today: drawHours(undefined)
	};

	filtersElement.innerHTML = filters.reduce(function(str, cur, key) {
		return str + h('div class="filter" data-filter="' + cur.Name + '"', h('span', cur.Name));
	}, '');

	dealersElement.on('click', '[filters-toggle]', function () {
		if (!this.classList.contains('open')) {
			this.classList.add('open');
			filtersElement.style.display = 'flex';
		} else {
			this.classList.remove('open');
			filtersElement.style.display = 'none';
		}
	});

	dealersElement.on('click', '[filters] > .filter', function() {
		var btn = this,
			key = btn.getAttribute('data-filter'),
			item = filters.find(function(itm) { return itm.Name === key; }),
			count;

		if (item.selected) {
			item.selected = false;
			btn.classList.remove('selected');
		}
		else {
			item.selected = true;
			btn.classList.add('selected');
		}

		count = dealersElement.querySelectorAll('[filters] > .selected').length;

		dealersElement.querySelector('[filters-toggle] > span').innerHTML = count > 0
			? ' (' + count + ')'
			: '';

		drawLocations({ container: dealersElement.querySelector('[list]'), locations, map, root });
	});

	dealersElement.on('click', 'button[search]', function (e) {
		if (e.isTrusted) {
			locationAllowed = true;
		}
		search(e)
	});
	dealersElement.on('keypress', 'input[name="location"]', function(e) {
		if (e.which == 13) {
			locationAllowed = true;
			search(e);
		}
	});

	dealersElement.on('click', 'button[route]', route);
	dealersElement.on('keypress', 'input[name="start"], input[name="end"]', function(e) {
		if (e.which == 13) {
			route(e);
		}
	});

	dealersElement.on('click', 'button[geo]', function() {
		var geo = this;
		fillGeo(this.parentNode.querySelector('input[type="text"]'))
			.then(function () {

				const alias = geo.getAttribute('data-button');

				if (alias === null) {
					console.error('A alias could not be found');
					return;
				}

				const btn = dealersElement.querySelector(`button[${alias}]`);

				if (btn === null) {
					console.error(`The button [${alias}] could not be found`);
					return;
				}
				
				domWrap(btn).trigger('click');
		});
	});

	dealersElement.on('click', '.dealer-pin-icon', function () {
		const markerIndex = this.getAttribute('data-marker-index');
		const visibleIndex = this.getAttribute('data-marker-visible-index')
		if (markerIndex !== null && locations[markerIndex]) {
			const marker = locations[markerIndex].marker;

			if (lastClickedMarker && lastClickedMarker !== marker) {
				if (lastClickedMarker.originalIcon) {
					lastClickedMarker.setIcon(lastClickedMarker.originalIcon);

					const prevVisibleIndex = lastClickedMarker.visibleIndex;

					lastClickedMarker.set('labelClass', 'marker-label high-z-label');
					lastClickedMarker.set('labelContent', prevVisibleIndex);

					setTimeout(() => {
						if (lastClickedMarker.label && lastClickedMarker.label.div) {
							lastClickedMarker.label.div.style.zIndex = (lastZ + 1).toString();
						} else if (marker.labelDiv) {
							lastClickedMarker.labelDiv.style.zIndex = (lastZ + 1).toString();
						} else {
							document.querySelectorAll('.high-z-label').forEach(el => {
								el.style.zIndex = (lastZ + 1).toString();
							});
						}
					}, 50);

					const currentMap = lastClickedMarker.getMap();
					if (currentMap) {
						const currentZIndex = lastClickedMarker.zIndex || 0;
						lastClickedMarker.setMap(null);
						lastClickedMarker.setMap(currentMap);
						lastClickedMarker.zIndex = currentZIndex; // Preserve z-index
					}
				}
			}

			// Now process the newly clicked marker
			lastZ += 1;
			marker.zIndex = lastZ;

			// Store the visible index for later restoration
			marker.visibleIndex = visibleIndex;

			// Store original icon if not already stored
			if (!marker.originalIcon) {
				marker.originalIcon = marker.getIcon();
			}

			const currentIcon = marker.getIcon();
			const iconUrl = (typeof currentIcon === 'string') ? currentIcon : currentIcon.url;

			const img = new Image();
			img.crossOrigin = "Anonymous";
			img.onload = function () {
				const canvas = document.createElement('canvas');
				canvas.width = img.width;
				canvas.height = img.height;
				const ctx = canvas.getContext('2d');

				ctx.drawImage(img, 0, 0);

				const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
				const data = imageData.data;

				// Loop through each pixel
				for (let i = 0; i < data.length; i += 4) {
					const red = data[i];
					const green = data[i + 1];
					const blue = data[i + 2];

					// RGB values all close to 255 indicate white
					if (red > 240 && green > 240 && blue > 240) {
						// Keep white pixels as they are
						continue;
					} else if (data[i + 3] > 0) {
						data[i] = 0;
						data[i + 1] = 0;
						data[i + 2] = 0;
					}
				}

				ctx.putImageData(imageData, 0, 0);

				const modifiedIconUrl = canvas.toDataURL();
				marker.setIcon({
					url: modifiedIconUrl,
					scaledSize: currentIcon.scaledSize,
					size: currentIcon.size,
					origin: currentIcon.origin,
					anchor: currentIcon.anchor
				});

				marker.set('labelContent', visibleIndex.toString());
				marker.set('labelClass', 'marker-label !tw-text-black high-z-label');
				marker.set('labelInBackground', false);

				setTimeout(() => {
					if (marker.label && marker.label.div) {
						marker.label.div.style.zIndex = (lastZ + 1).toString();
					} else if (marker.labelDiv) {
						marker.labelDiv.style.zIndex = (lastZ + 1).toString();
					} else {
						document.querySelectorAll('.high-z-label').forEach(el => {
							el.style.zIndex = (lastZ + 1).toString();
						});
					}
				}, 50);

				lastClickedMarker = marker;
			};
			img.src = iconUrl;
		}
	});
	dealersElement.on('click', 'div[close]', function() {
		// TODO Needs rewrite. Could cause side effects.
		[...document.querySelectorAll('[selected]')].forEach(element => element.innerHTML = '');
	})

	dealersElement.on('click', '#btnXLMap', function () {
		toggleFullScreen();
	});

	dealersElement.on('click', '#btnReduceMap', function () {		
		toggleFullScreen();
	});

	dealersElement.on('click', '.expandible .default', function() {
		this.classList.toggle('detail');
		domWrap(this.closest('.expandible')?.querySelector('.extended')).classList.toggle('expanded');
	});

	dealersElement.on('click', 'button.details', function() {
		if (isFullScreen()) {
			domWrap(this.closest('.location')?.querySelector('header h2 a')).trigger('click');
		} else {
			this.classList.toggle('detail');
			domWrap(this.closest('.location')?.querySelector('div.details')).classList.toggle('expanded');
		}
	});

	dealersElement
		.on('mouseenter','.location',function() {
			const marker = locations[this.getAttribute('data-index')].marker;
			lastZ += 1;
			marker.zIndex = lastZ;
			marker.setMap(map);
			marker.setAnimation(Maps.Animation.BOUNCE);
			setTimeout(() => marker.setAnimation(null), 500);
		})
		.on('mouseleave','.location', function() {
			locations[this.getAttribute('data-index')].marker.setAnimation(null);
		});

	dealersElement.on('click', '#btn-popup', () => {

		if (isFullScreen()) {
			detailsPopup.style.display = 'none';
			detailsPopup.classList.remove('tw-popup-open');			
		} else {
			detailsPopup.classList.remove('tw-popup-open');
			setTimeout(() => { detailsPopup.style.display = 'none'; }, 1000);
		}
	});

	[...dealersElement.querySelectorAll('input[name="location"],input[name="start"],input[name="end"]')].forEach(element => {
		if(Maps.places)
			new Maps.places.Autocomplete(element, { types: ['geocode'] });
	});
	
	[...dealersElement.querySelectorAll('[tab]')].forEach(button => {
		const target = button.getAttribute('data-target');
		if (target !== null) {
			const section = document.getElementById(target);
			if (section !== null) {
				const tab = {
					id: target,
					button,
					container: section
				};
				tabs.push(tab);

				button.onclick = () => {
					for (let i = 0, l = tabs.length; i < l; i++) {
						if (tabs[i].id === tab.id) {
							tabs[i].button.classList.add('selected');
							tabs[i].container.style.display = 'block';
						} else {
							tabs[i].button.classList.remove('selected');
							tabs[i].container.style.display = 'none';
						}
					}
				};
			}
		}		
	});

	setMap();

	function drawLocations({ container, locations, map, root = '' }) {
		const selectedFilters = filters.filter((x) => x.selected);

		const filteredLocations = locations.filter((location) => {
			return !selectedFilters.find((filter) => {
				return !filter.fnFilter(location);
			});
		});

		populateHeader(filteredLocations.length);

		populateListings(filteredLocations, selectedFilters, map);
	}
	function fillGeo(el) {
		const parent = el.parentNode;
		function cancel() {
			el.classList.remove('loading-location')
			el.removeEventListener('click', cancel);
		}

		if (parent.classList.contains('loading-location')) {
			return new Promise((resolve, reject) => reject());
		}
		return new Promise((resolve, reject) => {
			parent.classList.add('loading-location');
			parent.classList.remove('fallback');
			parent.addEventListener('click', cancel);

			svcGeoLocation.GetGeoLocation().getCurrentPosition(position => {
				if (!parent.classList.contains('loading-location'))
					return;

				geo.geocode(
					{ 'location': { lat: position.coords.latitude, lng: position.coords.longitude } },
					function (results, status) {
						if (!parent.classList.contains('loading-location'))
							return;
						if (status === Maps.GeocoderStatus.OK) {
							if (results[0]) {
								el.value = results[0].formatted_address;
								resolve();
							} else {
								reject();
								console.info('No results found');
							}
						} else {
							reject();
							console.info('Geocoder failed due to: ' + status);
						}
						parent.classList.remove('fallback')
						parent.classList.remove('loading-location')
						parent.removeEventListener('click', cancel);
					}
				);
			}, PosError => {
				console.log(PosError);
				locationAllowed = false;
				geoFallback(el).then(resolve).catch(reject);
				parent.classList.add('fallback')
				parent.removeEventListener('click', cancel);
			}, { enableHighAccuracy: true, maximumAge: 10000, timeout: navigator.userAgent.toLowerCase().indexOf("android") > -1 ? 15000 : 5000 });

		});
	}

	function getListings(opt, dataCach, url) {
		return new Promise((resolve, reject) => {
			if (!opt) {
				reject();
				return;
			}
			const hash = hashCode(JSON.stringify(opt));
			opt.type = 'DET';
			if (dataCach[hash]) {
				resolve(dataCach[hash]);
			} else {
				http(url).get(opt).then(data => {
					dataCach[hash] = data;
					resolve(data);
				}).catch(reject);
			}
		});
	}

	function geoFallback(el) {
		const parent = el.parentNode;
		return new Promise((resolve, reject) => {
			if (parent.classList.contains('loading-location') || el.value === '') {
				http('https://api.ipstack.com/check?access_key=7652d0f71a5071a6044703dc68df0d05&output=json&legacy=1')
					.get()
					.then(data => {
						if (data.city && data.region_code) {
							el.value = data.city + ', ' + data.region_code;
							resolve();
						}
						else {
							reject();
						}
						parent.classList.remove('loading-location');
					}).catch(() => {
						reject();
						parent.classList.remove('loading-location');
					});
			}
		});
	}

	function getDepartmentLookup(departments) {
		const collection = {};

		for (let i = 0, l = departments.length; i < l; i++) {

			const key = _.kebabCase(departments[i].type);

			const today = drawHours(departments[i].schedule[dayOfWeek]);
			today.status = `${today.status} Today`;

			collection[key] = {
				fax: departments[i].fax,
				phone: departments[i].phone,
				schedule: {
					sunday: drawHours(departments[i].schedule.sunday),
					monday: drawHours(departments[i].schedule.monday),
					tuesday: drawHours(departments[i].schedule.tuesday),
					wednesday: drawHours(departments[i].schedule.wednesday),
					thursday: drawHours(departments[i].schedule.thursday),
					friday: drawHours(departments[i].schedule.friday),
					saturday: drawHours(departments[i].schedule.saturday)
				},
				today
			}
		}

		return collection;
	}

	function getLocation(item, visibleIndex) {
		
		const encodedUrl = encodeURIComponent
			(`${item.address},${item.city},${item.state},${item.zip}`);

		const mapLink = `${mapURL}${encodedUrl}`;
		
		const isLocationOpen = isOpen(item);
		
		const address = titleCase
			(`${item.address}, ${item.city}, ${item.state} ${item.zip}`);

		const departments = getDepartmentLookup(item.departments);
		
		const showParts = departments['parts'] !== undefined;

		const parts = showParts ? departments['parts'] : _emptyDepartment;

		const showSales = departments['sales'] !== undefined;

		const sales = showSales ? departments['sales'] : _emptyDepartment;

		const showService = departments['service'] !== undefined;

		const service = showService ? departments['service'] : _emptyDepartment;
		
		const fullServiceList = item.services
			.concat(item.amenitiesList)
			.concat(item.productList)
			.sort()
			.map((x) => ' ' + x);
		
		const prepend = {
			addressDisplay: address,
			dealerUrl: `/dealer/${item.code}`,
			isClosed: !isLocationOpen,
			isOpen: isLocationOpen,
			mapLink,
			parts,
			sales,
			service,
			serviceList: fullServiceList.toString(),
			showDetails: !item.isInternational,
			showDirections: !item.isInternational,
			showDistance: !item.isInternational,
			showParts,
			showSales,
			showService,
			showWebsite: item.website !== undefined,
			visibleIndex
		}
		
		const copy = Object.assign(item, prepend);

		return copy;
	}

	function getMapListings(listings, selectedFilters, map) {
		const mapListings = [];

		const sortedListings = listings
			.sort((x, y) => x.distance - y.distance);

		for (let i = 0; i < sortedListings.length; i++) {

			const visibleIndex = i + 1;

			const location = getLocation(sortedListings[i], visibleIndex);			

			location.marker.label.set('labelContent', visibleIndex);
			location.marker.label.labelDiv.textContent = visibleIndex;
			location.marker.setMap(map);

			mapListings.push(location);
		}

		return mapListings;
	}

	function inputAlert(elements) {		
		setBorderColor(elements, 'red');

		setTimeout(() => { setBorderColor(elements, 'transparent'); }, 1000);
	}

	function loading(el) { }		

	function isOpen(location) {
		for (let i = 0, l = location.departments.length; i < l; i++) {
			const dep = location.departments[i];
			const minutesSinceMidnightGMT = Math.round(((new Date()).getTime() - (new Date()).setHours(0, 0, 0, 0)) / 60000) + (new Date()).getTimezoneOffset();
			const isLocationOpen = dep.schedule[dayOfWeek].status === 'Closed'
				? false
				: dep.schedule[dayOfWeek].status === 'AllDay'
				|| dep.schedule[dayOfWeek].open <= minutesSinceMidnightGMT && dep.schedule[dayOfWeek].close >= minutesSinceMidnightGMT;

			if (isLocationOpen)
				return true;
		}

		return false;
	}

	function locationInit(item, index) {
		item.marker = makeMarker(item);
		item.index = index;

		if (item.marker !== undefined) {
			item.marker.addListener('click', function () {
				const location = getLocation(item, 0);
				populateDetails(location)
			});

			if (item.marker.getMap() !== map) {
				item.marker.setMap(map);
			}
		}

		item.distance = Math.round(getDistance(item.latitude, item.longitude, currentLocation.lat(), currentLocation.lng()));

		if (item.entityType.indexOf('Distributor') > -1) {
			item['Distributor'] = true;
		}

		item.departments.forEach(function (dep) {
			if (!item.Distributor) {
				item[dep.type] = true;
			}
		});

		return item;
	}

	function makeMarker(item) {
		lastZ += 1;

		const iconConfig = {
			url: '/images/map-pin.png',
			size: new Maps.Size(42, 68),
			origin: new Maps.Point(0, 0),
			anchor: new Maps.Point(15, 49),
			scaledSize: new Maps.Size(30, 49)
		};

		const markerOptions = {
			position: new Maps.LatLng(item.latitude, item.longitude),
			title: item.name,
			zIndex: lastZ,
			draggable: false,
			clickable: true,
			labelContent: '',
			labelAnchor: new Maps.Point(-15, -40),
			labelClass: 'marker-label', // the CSS class for the label
			labelInBackground: false,
			icon: iconConfig
		};

		try {
			const marker = new MarkerWithLabel(markerOptions);
			marker.originalIcon = { ...iconConfig };
			return marker;
		}
		catch (e) {
			console.log('Error: ', e);
			return;
		}
	}

	function populateDetails(location) {
		
		popupBody.innerHTML = Mustache.render(popupTemplate.innerHTML, location);

		detailsPopup.style.display = 'block';
		setTimeout(() => { detailsPopup.classList.add('tw-popup-open'); }, 1);

		[...popupBody.querySelectorAll('[data-toggleHours]')].forEach((element) => {

			const targetAlias = element.getAttribute('data-toggleHours');

			if (targetAlias === null) {
				console.error('A target alias could not be found');
				return;
			}

			const target = document.getElementById(targetAlias);

			if (target === null) {
				console.error(`The target ${targetAlias} could not be found`);
				return;
			}

			element.onclick = () => {
				if (element.classList.contains('tw-icon-after-rotate')){
					element.classList.remove('tw-icon-after-rotate');
					target.style.display = 'none';
				} else {
					element.classList.add('tw-icon-after-rotate');
					target.style.display = 'block';
				}
			};
		});
	}

	function populateHeader(count) {
		const template = dealers.querySelector('[data-target="[TEMPLATE-LISTING-HEADER]"]');
		const targets = dealers.querySelectorAll('[data-target="[LISTING-HEADER]"]');

		const loadingTemplate = dealers.querySelector('[data-target="[TEMPLATE-LISTING-LOADING]"')
		const loadingTarget = dealers.querySelector('[data-target="[LISTING-LOADING]"')

		let locationSummary = `${count} Location`;

		if (count > 1)
			locationSummary += 's';

		locationSummary += ' Found';

		const model = {
			locationsFound: locationSummary,
			showLocationsFound: count > 0,
			showNoLocationsFound: count === 0
		};

		const loadingModel = {
			showLocationsFound: count > 0,
			showNoLocationsFound: count === 0 && locationAllowed,
			locationDisabled: !locationAllowed && count === 0
		}

		targets.forEach((target) => 
			{target.innerHTML = Mustache.render(template.innerHTML, model)}
		)
		loadingTarget.innerHTML = Mustache.render(loadingTemplate.innerHTML, loadingModel)
	}

	function populateListings(listings, selectedFilters, map) {

		const template = dealers.querySelector('[data-target="[TEMPLATE-LISTINGS]"]');

		const mapListings = getMapListings(listings, selectedFilters, map);
		
		listContainer.innerHTML = Mustache.render(template.innerHTML, { listings: mapListings });

		mapListings.forEach(location => {		
			
			const btnDetails = listContainer.querySelector(`[data-details="details-${location.index}"]`);
			
			if (btnDetails !== null)
				btnDetails.onclick = () => { populateDetails(location); };			
		});
	}			

	function route() {
		var boxes = [
			document.getElementById('txtStart'),
			document.getElementById('txtEnd')
		],
			addrFrom = (dealersElement.querySelector('input[name="start"]')?.value || '').trim(),
			addrTo = (dealersElement.querySelector('input[name="end"]')?.value || '').trim();
		if (addrFrom.length > 1 && addrTo.length > 1) {
			loading(listContainer);
			directionsService.route({
				origin: addrFrom,
				destination: addrTo,
				travelMode: Maps.TravelMode.DRIVING
			}, function (result, status) {
				var polyCoords;
				if (status == Maps.DirectionsStatus.OK) {
					polyCoords = getPolyCoords(result.routes[0].legs, (accuracy / 2) * 28);
					currentLocation = result.routes[0].legs[0].start_location;

					map = new Maps.Map(dealersElement.querySelector("[map]"), getOptions());
					directionsDisplay.setMap(map);
					directionsDisplay.setOptions({ suppressMarkers: true });
					directionsDisplay.setDirections(result);
					Maps.event.addListener(map, 'bounds_changed', _.throttle(function (event) {
						var bounds = map.getBounds(),
							ne = bounds.getNorthEast(),
							sw = bounds.getSouthWest();

						pendingCall = getListings({
							north: ne.lat(),
							south: sw.lat(),
							east: ne.lng(),
							west: sw.lng()
						}, dataCach, getListingsUrl).then(function (data) {
							cleanupLocations(locations);
							locations = data.filter(function (item) {
								return polyCoords.find(function (coord) {
									return getDistance(coord[0], coord[1], item.latitude, item.longitude) < accuracy;
								});
							}).map((item, index) => locationInit(item, index));
							drawLocations({ container: dealersElement.querySelector('[list]'), locations, map, root });
						}).catch(() => { });
					}, 500, { 'leading': false }));


				}
				else {
					console.info("Directions was not successful for the following reason: " + status);
					inputAlert(boxes);
				}
			});
		} else {
			if (addrFrom.length < 2) {
				inputAlert([boxes[0]]);
			}
			if (addrTo.length < 2) {
				inputAlert([boxes[1]]);
			}
		}
	}

	function search(e) {
		const tab = dealersElement.querySelector('[data-target="location"]');
		const addr = (dealersElement.querySelector('input[name="location"]')?.value || '').trim();


		if (addr.length > 1) {
			loading(listContainer);

			geo.geocode({ 'address': addr }, (results, status) => {
				if (status === Maps.GeocoderStatus.OK) {
					currentLocation = results[0].geometry.location;
					map = new Maps.Map(dealersElement.querySelector("[map]"), Object.assign({
						center: results[0].geometry.location
					}, getOptions()));
					Maps.event.addListener(map, 'bounds_changed', _.throttle(() => {
						const bounds = map.getBounds();
						const ne = bounds.getNorthEast();
						const sw = bounds.getSouthWest();
						const location = {
							north: ne.lat(),
							south: sw.lat(),
							east: ne.lng(),
							west: sw.lng()
						};

						pendingCall = getListings(location, dataCach, getListingsUrl)
							.then(data => {
								cleanupLocations(locations);
								locations = data.map((item, index) => locationInit(item, index));
								drawLocations({
									container: dealersElement.querySelector('[list]'),
									locations,
									map,
									root
								});
							}).catch(() => { });
					}, 500, { 'leading': false }));
				} else {
					console.info("Geocode was not successful for the following reason: " + status);
					inputAlert([document.getElementById('txtLocation')]);
				}
			});
		} else {
			inputAlert([document.getElementById('txtLocation')]);
		}
	}

	function setBorderColor(elements, color) {
		for (let i = 0, l = elements.length; i < l; i++)
			elements[i].style.borderColor = color;
	}

	function setMap() {

		const button = dealersElement.querySelector('.tw-btn-tab.selected');

		const btnAction = button.getAttribute('data-target');

		if (btnAction === 'location') {
			const location = document.getElementById('txtLocation');

			if (!location) {
				console.error('The text field "location" could not be found');
				return;
			}

			if (location.value !== '') {
				search();
				return;
			}
		} else if (btnAction === 'route') {
			const start = document.getElementById('txtStart');

			if (!start) {
				console.error('The text field "start" could not be found');
				return;
			}

			const end = document.getElementById('txtEnd');

			if (!end) {
				console.error('The text field "end" could not be found');
				return;
			}

			if (start.value !== '' && end.value !== '') {
				route();
				return;
			}
		}

		fillGeo(dealersElement.querySelector('input[name="location"],input[name="start"]'))
			.then(() => domWrap(dealersElement.querySelector('button[search]')).trigger('click'))
			.catch(() => { });
	}

	function toggleFullScreen() {

		const targets = dealers.querySelectorAll('[data-target="[LISTING-HEADER]"]');

		targets.forEach((target) => { 
			if (target.style.display === "none") {
				target.style.display = 'block';
			} else {
				target.style.display = 'none';
			}
		})
		const center = map.getCenter();

		let options = undefined;

		dealersElement.classList.toggle('fullscreen');

		options = getOptions();

		map.setZoom(options.zoom);

		document.body.classList.toggle('takeover-active');

		Maps.event.trigger(map, 'resize');

		map.setCenter(center);

		setMap();
	}
};